import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-cancel',
  templateUrl: './svg-cancel.component.html',
  styleUrls: ['./svg-cancel.component.css']
})
export class SvgCancelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
